import { PayloadAction, createSlice } from '@reduxjs/toolkit';

type SelectorState = { promoCountdownBanner: PromoCountdownBannerState };

export const PROMO_COUNTDOWN_DURATION_MS = 10 * 60 * 1000;

export type PromoCountdownBannerState = {
  startedAt: number | undefined;
};

export const initialPromoCountdownBannerState: PromoCountdownBannerState = {
  startedAt: undefined,
};

export const promoCountdownBannerSlice = createSlice({
  name: 'promoCountdownBanner',
  initialState: initialPromoCountdownBannerState,
  reducers: {
    startPromoCountdown: (
      state,
      action: PayloadAction<{ now: number }>,
    ) => {
      state.startedAt = action.payload.now;
    },
  },
});

export const promoCountdownEndsAt = (state: SelectorState) => {
  const { startedAt } = state.promoCountdownBanner;

  return startedAt === undefined
    ? undefined
    : startedAt + PROMO_COUNTDOWN_DURATION_MS;
};

export const { startPromoCountdown } = promoCountdownBannerSlice.actions;

export default promoCountdownBannerSlice.reducer;
